module.exports = __webpack_public_path__ + "static/img/htzlpic.9d8811e.png";


//////////////////
// WEBPACK FOOTER
// ./src/summary/assets/images/htzlpic.png
// module id = jKGc
// module chunks = 166